import {Spin, Tag, Tooltip, Typography} from "antd";
import {
    CheckCircleOutlined,
    ClockCircleOutlined,
    CloseCircleOutlined,
    SyncOutlined,
    StopOutlined,
    IssuesCloseOutlined,
    CheckOutlined,
    HeartOutlined, CheckCircleTwoTone
} from "@ant-design/icons";
import React from "react";

const { Text } = Typography;


export const getTagForRuntimeStates = (status: string) => {
  switch (status) {
    case 'IN_SERVICE':
      return <Tag icon={<CheckCircleOutlined />} color="success">In Service</Tag>
    case 'REQUESTED':
      return <Tag icon={<SyncOutlined />} color="processing">Requested</Tag>
    case 'DECOMMISSIONED':
      return <Tag icon={<CloseCircleOutlined />} color="pink">Decommissioned</Tag>
    default:
      return <Tag icon={<ClockCircleOutlined />} color="default">{status}</Tag>
  }
}


export const getTagForChangeState = (change_state: string) => {
  switch (change_state) {
    case 'ALL_CHANGES_COMPLETED':
      return <Tag style={{marginRight:0}} icon={<CheckCircleOutlined />} color="#95de64">All Changes Completed</Tag>
    case 'CHANGES_PENDING':
      return <Tag style={{marginRight:0}} icon={<SyncOutlined />} color="default">Changes Pending</Tag>
    case 'CHANGES_REJECTED':
      return <Tag style={{marginRight:0}} icon={<StopOutlined />} color="orange">Changes Rejected</Tag>
    case 'CHANGES_ERRORED':
      return <Tag style={{marginRight:0}} icon={<CloseCircleOutlined />} color="#ff7875">Error in Changes</Tag>
    case 'CHANGES_APPROVED':
      return <Tag style={{marginRight:0}} icon={<ClockCircleOutlined />} color="#69c0ff">Changes Approved</Tag>
    default:
      return <Tag style={{marginRight:0}} icon={<ClockCircleOutlined />} color="default">{change_state}</Tag>
  }
}


export const getFilterTextForChangeState = (change_state: string) => {
  switch (change_state) {
    case 'ALL_CHANGES_COMPLETED':
      return 'COMPLETED';
    case 'CHANGES_PENDING':
      return 'PENDING,APPROVED';
    case 'CHANGES_ERRORED':
      return 'ERROR';
    default:
      return '';
  }
}


export const getTagForChangeTypes = (change_type: string) => {
  switch (change_type) {
    case 'CREATE':
      return <Tag icon={<CheckCircleOutlined />} color="success">CREATE</Tag>
    case 'MODIFY':
      return <Tag icon={<SyncOutlined />} color="processing">MODIFY</Tag>
    case 'DELETE':
      return <Tag icon={<CloseCircleOutlined />} color="error">DELETE</Tag>
    default:
      return <Tag icon={<ClockCircleOutlined />} color="default">{change_type}</Tag>
  }
}


export const getTagForStates = (state: string) => {
  switch (state) {
    case 'PENDING':
      return <Tag icon={<ClockCircleOutlined />} color="default">PENDING</Tag>
    case 'REJECTED':
      return <Tag icon={<StopOutlined />} color="orange">REJECTED</Tag>
    case 'APPROVED':
      return <Tag icon={<CheckCircleOutlined />} color="#69c0ff">APPROVED</Tag>
    case 'ERROR':
      return <Tag icon={<CloseCircleOutlined />} color="#ff7875">ERROR</Tag>
    case 'CLOSED':
      return <Tag icon={<IssuesCloseOutlined />} color="default">CLOSED</Tag>
    case 'COMPLETED':
      return <Tag icon={<CheckOutlined />} color="#95de64">COMPLETED</Tag>
    default:
      return <Tag icon={<ClockCircleOutlined />} color="default">{state}</Tag>
  }
}


export const getTagForResponsesStatus = (status_code: number) => {
  if (!status_code)
    return <Tag>No response</Tag>
  if (status_code >= 200 && status_code < 300)
    return <Tag  icon={<HeartOutlined />}  color="#108ee9">{status_code}</Tag>
  else if (status_code >= 400)
    return <Tag  icon={<HeartOutlined />}  color="#f50">{status_code}</Tag>

  return <Tag icon={<HeartOutlined />}>{status_code}</Tag>
}

export const PriceTag = ({ amount, currency="GBP" }: { amount: number, currency: string }) => {
    const formatter = new Intl.NumberFormat(undefined, { style: 'currency', currency: currency,});
    return <>{formatter.format(amount)}</>
}

export const renderNameAndTagWithEllipsis = (name: string, tags: [string], maxWidth: number) => {
  let total_length = name.length;
  const tagsRender: JSX.Element[] = []
  for(const tag in tags){
    tagsRender.push(
        <Tag><Text style={{ fontSize: '12px' }} type="secondary">#{tags[tag]}</Text></Tag>
    )
    total_length += tags[tag].length
    if (total_length >= maxWidth){
      tagsRender.push(<>...</>)
      break
    }
  }
  return (
      <>
        <Tooltip
            placement="right"
            title={<><Text type="secondary" style={{ font: "#363636" }}>Tags:  </Text>{tags?.map((tag: any) => <Tag>#{tag}</Tag>)}</>}
            color={"#ffffff"}
        >
          {tagsRender.map((tagRender: any) => tagRender)}
        </Tooltip>
      </>
  )
}


export const getTagForServiceState = (state: string) => {
  switch (state) {
    case 'IN_SERVICE':
      return <></>
      // return <Tag icon={<CheckCircleOutlined/>} color="success">In Service</Tag>
      // Show tags only if not IN_SERVICE
    case 'NO_NEW_SERVICE_ITEM':
      return <Tag icon={<SyncOutlined/>} color="warning">Not Accepting New Service Items</Tag>
    case 'NO_MODIFY_EXISTING_SERVICE_ITEM':
      return <Tag icon={<CloseCircleOutlined/>} color="error">Decommissioning Only Allowed</Tag>
    case 'DECOMMISSIONED':
      return <Tag icon={<CloseCircleOutlined/>} color="pink">Decommissioned</Tag>
  }
}


export const getTagForEvaluation = (evaluation_result: any) => {
  if (evaluation_result?.state === "WAITING_FOR_RESPONSE")
    return <Tag icon={<SyncOutlined spin />} color="processing">Evaluation in progress</Tag>

  else if (evaluation_result?.state === "FAILED")
    return <Tag icon={<CloseCircleOutlined />} color="error">Evaluation Failed</Tag>

  else if (evaluation_result?.state === "OK")
    return <Tag icon={<CheckCircleOutlined />} color="success">Accuracy: {parseFloat(evaluation_result?.accuracy)*100}%</Tag>

  return <></>
}


export const getTagForAIProcessResponse = (state: string) => {
    if(state==="WAITING_FOR_RESPONSE")
        return <Tag icon={<SyncOutlined spin />} color="processing">Waiting...</Tag>;
    else if (state==="OK")
        return <Tag icon={<CheckCircleTwoTone twoToneColor="#52c41a" />} color="success">OK</Tag>;
    else if (state==="FAILED")
        return <Tag color="error">Failed</Tag>;
    else
        return <Tag>{state}</Tag>;
}
